<template>
  <v-main
    id="pages"
    :class="1 == 1 || $vuetify.theme.dark ? undefined : 'grey lighten-3'"
  >
    <v-img
      :class="{
        'v-image--sm': this.$vuetify.breakpoint.smAndDown,
        'v-image--md': this.$vuetify.breakpoint.mdAndDown,
      }"
      :src="src"
      gradient="to top, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)"
      min-height="100%"
    >
      <v-responsive :style="styles" min-height="100vh" class="align-center">
        <router-view />
      </v-responsive>
    </v-img>
  </v-main>
</template>

<script>
export default {
  name: "PagesCoreView",
  props: {
    errorId: {
      type: String,
      default: null,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    srcs: {
      "/error/systemDown": "/public/portal/getImage/THEME/error",
      "/auth/lock": "/public/portal/getImage/THEME/lock",
      "/auth/login": "/public/portal/getImage/THEME/login",
      "/auth/register": "/public/portal/getImage/THEME/register",
      "/publicDashboard/dashboardGara": "/public/portal/getImage/THEME/login",
    },
  }),

  computed: {
    src() {
      let path = this.$route.path;
      if (path.startsWith("/publicDashboard/dashboardGara"))
        path = "/publicDashboard/dashboardGara";
      if (!this.srcs[path] || path.startsWith("/error/")) return "/error.jpg";

      if (this.srcs[path]) {
        let image = this.externalizeLink(this.srcs[path]);

        return image;
      } else return undefined;
    },
    styles() {
      let paddingTop = 0;
      let paddingBottom = 0;
      if (!this.fullscreen) {
        paddingTop = this.$vuetify.breakpoint.mdAndUp ? 175 : 100;
        paddingBottom = this.$vuetify.breakpoint.mdAndUp ? 175 : 150;
      }
      return {
        padding: `${paddingTop}px 0 ${paddingBottom}px 0`,
      };
    },
  },
};
</script>
<style >
#pages .v-responsive__sizer {
  padding-bottom: 0px !important;
}
</style>
